// extracted by css-extract-rspack-plugin
export default {"root":"aKeaRc","content":"OQP9m9","footer":"RMGAdP","button":"lymT57","button-decline":"oH0ES2","buttonDecline":"oH0ES2"};